import enpoints from "../endpoints"
import { axiosInstance } from "../instance"

export const sendTestInvitation = (params: any) => {
  return axiosInstance.post(enpoints.TEST, params)
}
